export default "__VITE_ASSET__CfVwPp22__"